import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const ResizeIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M16.2422 11.1514C16.7108 10.6828 17.4708 10.6828 17.9395 11.1514C18.4081 11.62 18.4081 12.38 17.9395 12.8486L12.8486 17.9395C12.38 18.4081 11.62 18.4081 11.1514 17.9395C10.6828 17.4708 10.6828 16.7108 11.1514 16.2422L16.2422 11.1514ZM15.334 5.15138C15.8026 4.68294 16.5617 4.68294 17.0303 5.15138C17.4989 5.62001 17.4989 6.38002 17.0303 6.84865L6.84865 17.0303C6.38002 17.4989 5.62001 17.4989 5.15138 17.0303C4.68294 16.5617 4.68294 15.8026 5.15138 15.334L15.334 5.15138Z'
        fill={color}
      />
    </svg>
  )
})
